import { Text, Tooltip } from "@mantine/core"

import { truncateLabel } from "@costory/front/utils/charts"

interface TruncatedHeaderProps {
  label: string
  maxLength?: number
  fontWeight?: number
}

export const TruncatedHeader = ({
  label,
  maxLength = 30,
  fontWeight = 650,
}: TruncatedHeaderProps) => {
  const truncatedLabel = truncateLabel(label, maxLength)

  return (
    <Tooltip label={label} withArrow disabled={label.length <= maxLength}>
      <Text
        size="sm"
        fw={fontWeight}
        onCopy={(e) => {
          e.preventDefault()
          e.clipboardData.setData("text/plain", label)
        }}
      >
        {truncatedLabel}
      </Text>
    </Tooltip>
  )
}
